module.exports = __webpack_public_path__ + "static/media/jegs_home-page-menu.ec8744cd.jpg";